import "./App.css";
import '@progress/kendo-theme-default/dist/all.css';
import { styled, createGlobalStyle } from "styled-components";

import * as React from 'react';
import { Route, Routes } from "react-router-dom";
import CampaignHome from "./Pages/Campaign/CampaignHome/CampaignHome";
import LoginHub from "./Pages/Login/LoginHub";
import Alerts from "./Components/Alerts";



// export const RequireAuth = ({ children }) => {
//   const token = localStorage.getItem("token");

//   if (!token) {
//     return <Navigate to="/login" replace={true} />
//   }

//   return children
// };
const GlobalStyles = createGlobalStyle`
    :root {
        --kendo-color-base-hover:rgb(235, 235, 235);
        --kendo-color-base-active: white;
        
        --kendo-color-primary: ${(props) => props.primarycolor};
        --kendo-color-primary-hover: #224db3;
        --kendo-color-primary-active: #3e61b3;
    }
`;



// const Style = styled('div')`
//     & .k-color-primary {
//         // color:${(props) => props.primarycolor} ;
//     }
//     & .k-button-solid-primary {
//         // border-color:${(props) => props.primarycolor} !important;
//         // background-color:${(props) => props.primarycolor} !important;
//     }

//      :root { 
//         --kendo-color-primary: ${(props) => props.primarycolor};
//         --kendo-color-primary-hover: #c66;
//         --kendo-color-on-base: ${(props) => props.primarycolor};

//     }
// `;


function App() {

  // Alert states
  const [alertState, setAlertState] = React.useState({
    success: false,
    error: false,
    warning: false,
    info: false,
    none: false,
  });

  // Alert Message
  const [alertMessage, setAlertMessage] = React.useState("");

  const onTriggerAlert = (flag) => {

    setAlertState({
      ...alertState,
      [flag]: !alertState[flag],
    });

    // Cleanup alert after 5 secs
    setTimeout((flag) => {
      setAlertState({
        ...alertState,
        [flag]: !alertState[flag],
      })
    }, "4000");
  }

  return (
    <React.Fragment>
      <GlobalStyles primarycolor={"#083db8"} />

      <Routes>
        <Route path="" element={<LoginHub onTriggerAlert={(flag) => onTriggerAlert(flag)} setAlertMessage={setAlertMessage} />} />
        <Route path="campaign-home" element={<CampaignHome onTriggerAlert={(flag) => onTriggerAlert(flag)} setAlertMessage={setAlertMessage} />} />

        {/* <Route path="Campaign-sites" element={
          <RequireAuth>
          <CampaignSites onTriggerAlert={(flag) => onTriggerAlert(flag)} setAlertMessage={setAlertMessage} />
          </RequireAuth>} /> */}

        {/* Default redirects back to home if you put a random link that doesn't have a path */}
        {/* <Route path="*" element={<Navigate to="/" replace={true} />} /> */}
      </Routes>

      <Alerts setAlertState={setAlertState} alertState={alertState} alertMessage={alertMessage} setAlertMessage={setAlertMessage} onTriggerAlert={(flag) => onTriggerAlert(flag)} />

    </React.Fragment >

  )
}

export default App;
